import { AnyAction } from "redux";
import { FindById, Update } from "../../../actorTyes";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { Adapter } from "../../../../shared/adapter";
import { ActorTypesAdapter } from "../../../../adapter/actorTypes-adapter";

export const FETCH_UPDATE_ACTOR_TYPE_REQUEST = 'FETCH_UPDATE_ACTOR_TYPE_REQUEST';
export const FETCH_UPDATE_ACTOR_TYPE_SUCCESS = 'FETCH_UPDATE_ACTOR_TYPE_SUCCESS';
export const FETCH_UPDATE_ACTOR_TYPE_FAILURE = 'FETCH_UPDATE_ACTOR_TYPE_FAILURE';
export const SET_UPDATE_ACTOR_TYPE = 'SET_UPDATE_ACTOR_TYPE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchUpdateActorTypeRequest = () => {
    return {
        type: FETCH_UPDATE_ACTOR_TYPE_REQUEST,
    };
};

const fetchUpdateActorTypeSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_UPDATE_ACTOR_TYPE_SUCCESS,
        payload: data
    };
};

const fetchUpdateActorTypeFailure = (error: any) => {
    return {
        type: FETCH_UPDATE_ACTOR_TYPE_FAILURE,
        payload: error,
    };
};

export const setUpdateActorType = (data: any) => {
    return {
        type: SET_UPDATE_ACTOR_TYPE,
        payload: data,
    };
};

export const update = (id: string, data: any) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchUpdateActorTypeRequest());
        try {
            const response = await Update(id, data);
            dispatch(fetchUpdateActorTypeSuccess(
                Adapter.from(response.data).to((value) => new ActorTypesAdapter(value).adapt())
            ));
        } catch (error: any) {
            dispatch(fetchUpdateActorTypeFailure(error.message));
        }
    };
};

export const findById = (id: string) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchUpdateActorTypeRequest());
        try {
            const response = await FindById(id);
            dispatch(setUpdateActorType(
               response.data
            ));
        } catch (error: any) {
            dispatch(fetchUpdateActorTypeFailure(error.message));
        }
    };
};
